

























































































































































































import { Component, Vue } from 'vue-property-decorator'

@Component({ components: {} })
export default class Download extends Vue {
  loaded: boolean = false // 页面是否已经加载完成
  downloadStatus = {
    xingsuan: false,
    xsteacher: false,
    plstudent: false
  }
  to (path: string) {
    Lib.router.push(path)
  }
  hideDownload (appName: string) {
    if (appName === 'xingsuan') {
      this.downloadStatus.xingsuan = false
    } else if (appName === 'xsteacher') {
      this.downloadStatus.xsteacher = false
    } else if (appName === 'plstudent') {
      this.downloadStatus.plstudent = false
    }
  }
  showDownload (appName: string) {
    if (appName === 'xingsuan') {
      this.downloadStatus.xingsuan = true
    } else if (appName === 'xsteacher') {
      this.downloadStatus.xsteacher = true
    } else if (appName === 'plstudent') {
      this.downloadStatus.plstudent = true
    }
  }
  created () {
    this.loaded = true
  }
  mounted () {
    let anchor = null
    if (this.$route.query.anchor === 'ketang') {
      anchor = document.querySelector('.product-ketang-item')
    } else if (this.$route.query.anchor === 'chuti') {
      anchor = document.querySelector('.product-chuti-item')
    } else if (this.$route.query.anchor === 'xingsuan') {
      anchor = document.querySelector('.product-xingsuan-item')
    } else if (this.$route.query.anchor === 'xsteacher') {
      anchor = document.querySelector('.product-xsteacher-item')
    } else if (this.$route.query.anchor === 'plketang') {
      anchor = document.querySelector('.product-plketang-item')
    } else if (this.$route.query.anchor === 'plstudent') {
      anchor = document.querySelector('.product-plstudent-item')
    }
    if (anchor) {
      document.documentElement.scrollTop = (anchor as HTMLElement).offsetTop - 60
      document.body.scrollTop = (anchor as HTMLElement).offsetTop - 60
    }
    // 兼容prerender-spa-plugin
    Lib.dispatchEvent(document, 'custom-render-trigger')

    // 珠心算学生端事件监听
    let downloadXingsuan = document.querySelector('.product-item-download-xingsuan')
    let btnCloseXingsuan = document.querySelector('.product-item-close-xingsuan')
    let btnDownloadXingsuan = document.querySelector('.product-btn-download-xingsuan')
    if (btnDownloadXingsuan && downloadXingsuan) {
      btnDownloadXingsuan.addEventListener('click', () => {
        downloadXingsuan!.classList.add('show')
      })
    }
    if (btnCloseXingsuan && downloadXingsuan) {
      btnCloseXingsuan.addEventListener('click', () => {
        downloadXingsuan!.classList.remove('show')
      })
    }

    // 珠心算管理端事件监听
    let downloadXsteacher = document.querySelector('.product-item-download-xsteacher')
    let btnCloseXsteacher = document.querySelector('.product-item-close-xsteacher')
    let btnDownloadXsteacher = document.querySelector('.product-btn-download-xsteacher')
    if (btnDownloadXsteacher && downloadXsteacher) {
      btnDownloadXsteacher.addEventListener('click', () => {
        downloadXsteacher!.classList.add('show')
      })
    }
    if (btnCloseXsteacher && downloadXsteacher) {
      btnCloseXsteacher.addEventListener('click', () => {
        downloadXsteacher!.classList.remove('show')
      })
    }

    // 珠心算无纸化学生端事件监听
    let downloadPlstudent = document.querySelector('.product-item-download-plstudent')
    let btnClosePlstudent = document.querySelector('.product-item-close-plstudent')
    let btnDownloadPlstudent = document.querySelector('.product-btn-download-plstudent')
    if (btnDownloadPlstudent && downloadPlstudent) {
      btnDownloadPlstudent.addEventListener('click', () => {
        downloadPlstudent!.classList.add('show')
      })
    }
    if (btnClosePlstudent && downloadPlstudent) {
      btnClosePlstudent.addEventListener('click', () => {
        downloadPlstudent!.classList.remove('show')
      })
    }
  }
}
